var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"applySuccess"},[_c('div',{staticClass:"title1"},[_vm._v("申请成功")]),_c('div',{staticClass:"dec1"},[_vm._v("可在列表查看您可成功申请的订单")]),_c('div',{staticClass:"btnBlueClass1",on:{"click":_vm.continuCreate}},[_vm._v("继续申请")])])}
var staticRenderFns = []

export { render, staticRenderFns }